import { crearRegistro, actualizarRegistro, eliminarRegistro } from "../../../functions/crud";
import Swal from "sweetalert2";
const generarFormularioHTML = (datos = {}) => {
    const { tipoDireccion = "", manzana = "", numeroCasa = "", numeroTorre = "", numeroApartamento = "", coeficiente = "" } = datos;

    return `
        <div style="display: flex; flex-direction: column; gap: 16px; text-align: left; max-width: 400px; margin: 0 auto;">
            <div style="display: flex; flex-direction: column; gap: 8px;">
                <label style="font-size: 14px; font-weight: 500;">Tipo de dirección</label>
                <select id="tipoDireccion" style="padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white;">
                    <option value="">Selecciona</option>
                    <option value="casa" ${tipoDireccion === "casa" ? "selected" : ""}>Casa</option>
                    <option value="apartamento" ${tipoDireccion === "apartamento" ? "selected" : ""}>Apartamento</option>
                </select>
            </div>

            <div id="inputsCasa" style="display: ${tipoDireccion === "casa" ? "flex" : "none"}; flex-direction: column; gap: 8px;">
                <div style="display: flex; gap: 12px;">
                    <div style="flex: 1;">
                        <label style="font-size: 14px; font-weight: 500;">Manzana</label>
                        <input id="manzana" value="${manzana}" style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; box-sizing: border-box;" placeholder="Número">
                    </div>
                    <div style="flex: 1;">
                        <label style="font-size: 14px; font-weight: 500;">Casa</label>
                        <input id="numeroCasa" value="${numeroCasa}" style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; box-sizing: border-box;" placeholder="Número">
                    </div>
                </div>
            </div>

            <div id="inputsTorre" style="display: ${tipoDireccion === "apartamento" ? "flex" : "none"}; flex-direction: column; gap: 8px;">
                <div style="display: flex; gap: 12px;">
                    <div style="flex: 1;">
                        <label style="font-size: 14px; font-weight: 500;">Torre</label>
                        <input id="numeroTorre" value="${numeroTorre}" style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; box-sizing: border-box;" placeholder="Número">
                    </div>
                    <div style="flex: 1;">
                        <label style="font-size: 14px; font-weight: 500;">Apartamento</label>
                        <input id="numeroApartamento" value="${numeroApartamento}" style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; box-sizing: border-box;" placeholder="Número">
                    </div>
                </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 8px;">
                <label style="font-size: 14px; font-weight: 500;">Coeficiente del Apartamento</label>
                <input id="coeficiente" type="number" step="0.001" min="0" max="1" value="${coeficiente}"
                    style="padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px;" 
                    placeholder="Ej: 0.05">
            </div>
        </div>
    `;
};
const configurarEventosFormulario = () => {
    const tipoDireccionSelect = document.getElementById("tipoDireccion");
    const inputsCasa = document.getElementById("inputsCasa");
    const inputsTorre = document.getElementById("inputsTorre");

    tipoDireccionSelect.addEventListener("change", () => {
        const valor = tipoDireccionSelect.value;
        inputsCasa.style.display = valor === "casa" ? "flex" : "none";
        inputsTorre.style.display = valor === "apartamento" ? "flex" : "none";
    });
};
const validarYObtenerDatos = () => {
    const tipoDireccion = document.getElementById("tipoDireccion").value;
    const coeficiente = document.getElementById("coeficiente").value;

    if (!tipoDireccion || !coeficiente) {
        Swal.showValidationMessage("Completa todos los campos obligatorios");
        return false;
    }

    const coeficienteNum = parseFloat(coeficiente);
    if (isNaN(coeficienteNum) || coeficienteNum <= 0) {
        Swal.showValidationMessage("El coeficiente debe ser mayor a 0");
        return false;
    }

    let direccion = "";
    if (tipoDireccion === "apartamento") {
        const numeroTorre = document.getElementById("numeroTorre").value;
        const numeroApartamento = document.getElementById("numeroApartamento").value;
        if (!numeroTorre || !numeroApartamento) {
            Swal.showValidationMessage("Completa el número de torre y apartamento");
            return false;
        }
        direccion = `TORRE ${numeroTorre} APARTAMENTO ${numeroApartamento}`;
    } else if (tipoDireccion === "casa") {
        const manzana = document.getElementById("manzana").value;
        const numeroCasa = document.getElementById("numeroCasa").value;
        if (!manzana || !numeroCasa) {
            Swal.showValidationMessage("Completa el número de manzana y casa");
            return false;
        }
        direccion = `MANZANA ${manzana} CASA ${numeroCasa}`;
    }

    return { direccion, coeficiente: coeficienteNum };
};
const extraerDatosDireccion = (direccion) => {
    if (!direccion) return {};

    if (direccion.includes("TORRE") && direccion.includes("APARTAMENTO")) {
        const torreMatch = direccion.match(/TORRE\s+(\S+)/);
        const aptoMatch = direccion.match(/APARTAMENTO\s+(\S+)/);
        return {
            tipoDireccion: "apartamento",
            numeroTorre: torreMatch?.[1] || "",
            numeroApartamento: aptoMatch?.[1] || ""
        };
    } else if (direccion.includes("MANZANA") && direccion.includes("CASA")) {
        const manzanaMatch = direccion.match(/MANZANA\s+(\S+)/);
        const casaMatch = direccion.match(/CASA\s+(\S+)/);
        return {
            tipoDireccion: "casa",
            manzana: manzanaMatch?.[1] || "",
            numeroCasa: casaMatch?.[1] || ""
        };
    }
    return {};
};

export const crearCopropietario = async () => {
    const { value: formValues } = await Swal.fire({
        title: "Crear Vivienda en Censo",
        html: generarFormularioHTML(),
        didOpen: configurarEventosFormulario,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Crear Vivienda",
        cancelButtonText: "Cancelar",
        width: 500,
        customClass: { popup: 'swal2-popup-custom' },
        preConfirm: () => {
            const datos = validarYObtenerDatos();
            if (!datos) return false;

            return {
                ...datos,
                fecha: new Date().toISOString(),
                usuario: localStorage.getItem("CorreoElectronico")
            };
        }
    });

    if (formValues) {
        try {
            const nit = localStorage.getItem("CodigoCliente");
            await crearRegistro(`coordi_ph/${nit}/censo/`, formValues);
            Swal.fire("Éxito", "Vivienda creada correctamente en el censo", "success");
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "No se pudo crear la vivienda en el censo", "error");
        }
    }
};

export const editarCopropietario = async (fila) => {
    const datosExistentes = {
        ...extraerDatosDireccion(fila.direccion),
        coeficiente: fila.coeficiente || ""
    };

    const { value: formValues } = await Swal.fire({
        title: "Editar Vivienda en Censo",
        html: generarFormularioHTML(datosExistentes),
        didOpen: configurarEventosFormulario,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Guardar Cambios",
        cancelButtonText: "Cancelar",
        width: 500,
        customClass: { popup: 'swal2-popup-custom' },
        preConfirm: () => {
            const datos = validarYObtenerDatos();
            if (!datos) return false;

            return {
                ...datos,
                fechaActualizacion: new Date().toISOString(),
                usuarioActualizacion: localStorage.getItem("CorreoElectronico")
            };
        }
    });

    if (formValues) {
        try {
            const nit = localStorage.getItem("CodigoCliente");
            const ruta = `coordi_ph/${nit}/censo/${fila.id}`;
            await Promise.all([
                actualizarRegistro(`${ruta}/direccion`, formValues.direccion),
                actualizarRegistro(`${ruta}/coeficiente`, formValues.coeficiente),
                actualizarRegistro(`${ruta}/fechaActualizacion`, formValues.fechaActualizacion),
                actualizarRegistro(`${ruta}/usuarioActualizacion`, formValues.usuarioActualizacion)
            ]);

            Swal.fire("Éxito", "Vivienda actualizada correctamente en el censo", "success");
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "No se pudo actualizar la vivienda en el censo", "error");
        }
    }
};

export const eliminarCopropietario = async (fila) => {
    try {
        const { isConfirmed } = await Swal.fire({
            title: "¿Eliminar Copropietario?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        });

        if (isConfirmed) {
            const nit = localStorage.getItem("CodigoCliente");
            await eliminarRegistro(`coordi_ph/${nit}/censo/${fila.id}`);
            Swal.fire("Eliminado", "El copropietario fue eliminado correctamente", "success");
        }
    } catch (error) {
        console.error(error);
        Swal.fire("Error", "No se pudo eliminar el copropietario", "error");
    }
};